export const DEFAULT_DEAL_MIRROR_PLAN_NAME = "Lifetime Jugl Pro";
